import React from 'react';

import useLediumPage from '@client/hooks/useLediumPage';
import { usePageStore } from '@client/store/pageStore/context/pageContext';

import LightChannelsView from './LightChannelsView';

const LightChannels = () => {
    const {
        pageState: { formData }
    } = usePageStore();

    const { mainMenu, onSave } = useLediumPage({
        saveCondition: () => !!(formData.spectrogram as unknown[]).length,
        saveDataMap: () => ({
            name: formData.name,
            description: formData.description,
            resolution: [1, 8, 16, 24, 32].includes(formData.resolution as number) ? formData.resolution : 8,
            channel: +(formData.channel as string | number),
            spectrogram: formData.spectrogram,
            groupId: formData.groupId,
            csvData: formData.csvData,
            spectrogramRanges: formData.spectrogramRanges
        })
    });

    if (!formData.loaded) {
        return null;
    }

    return <LightChannelsView onClose={mainMenu} onSave={onSave} />;
};

export default LightChannels;
